module.exports = __webpack_public_path__ + "static/shopify-bbva-0d491857799fd169f690dd0eff82d34b.svg";